import { Component, OnInit } from '@angular/core';
import { EvaluationSystemService } from '../../services/evaluation-system.service';
import { Router } from '@angular/router';
import { IsAdmin } from '../../guards/isAdmin';
import { Evaluation } from '../../services/GI.Web.Services.g';

@Component({
  selector: 'app-admin-connect-list',
  templateUrl: './admin-connect-list.component.html',
  styleUrls: ['./admin-connect-list.component.css']
})
export class AdminConnectListComponent implements OnInit {
  constructor(
      private _evaluationSystemService: EvaluationSystemService,
      private _router: Router,
      public _adminGuard: IsAdmin) { }

  public evaluationsReady = true;
  public evaluations: Evaluation[] = [];
  public cols: any[] = [];
  public periodStatuses: any[] = [];

  ngOnInit() {
      this._adminGuard.canActivate();
      this.setColumns();
      // this.setPeriodStatuses();
      this.getEvaluations();
  }

  setColumns() {
      this.cols = [
          { field: 'displayName', header: 'Name', width: '60%' },
          { field: 'periodStatus', header: 'Status', width: '30%' },
          { field: '', header: '', width: '10%' }
      ];
  }

  getEvaluations() {
      this._evaluationSystemService.getAllEvaluations().subscribe(results => {
          this.evaluations = results;
          this.evaluationsReady = true;
      });
  }

  navigateToDetail(evaluationName: string) {
      this._router.navigate(['/adminconnectdetail/' + encodeURIComponent(evaluationName)]);
  }

  addEvaluation() {
      this._router.navigate(['/adminconnectdetail/new']);
  }
}



// WEBPACK FOOTER //
// ./src/app/components/admin-connect-list/admin-connect-list.component.ts